import { render, staticRenderFns } from "./VVehicles.vue?vue&type=template&id=c93953e8&"
import script from "./VVehicles.vue?vue&type=script&lang=js&"
export * from "./VVehicles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lucas/projects/work/autoag/autoagtruck.ch/wp-content/themes/autoag/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c93953e8')) {
      api.createRecord('c93953e8', component.options)
    } else {
      api.reload('c93953e8', component.options)
    }
    module.hot.accept("./VVehicles.vue?vue&type=template&id=c93953e8&", function () {
      api.rerender('c93953e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/scripts/VVehicles/VVehicles.vue"
export default component.exports